export enum ColorsEnum {
    PRIMARY = '#C00A27',
    PRIMARY_LIGHT = '#E3405B',
    SECONDARY_DARK = '#4064A2',
    SECONDARY = '#4064A2',
    SECONDARY_LIGHT = '#00AAFF',
    SUCCESS = '#33C47C',
    DARK = '#2E2E2D',
    GRAY = '#C6C6C6',
    GRAY_DARK = '#686868',
    GRAY_LIGHT = '#F5F5F5',
    YELLOW = '#EFFF17',
}

export enum OrderColorEnum {
    LimeGreen = '#7CFC00',
    LightSkyBlue = '#87CEFA',
    LightSalmon = '#FFA07A',
    LightGray = '#D3D3D3',
    LightCoral = '#FF7F7F',
    White = '#FFFFFF',
}

export const orderColorNameDictionary = {
    [OrderColorEnum.LimeGreen]: 'Světle zelená',
    [OrderColorEnum.LightSkyBlue]: 'Světle modrá',
    [OrderColorEnum.LightSalmon]: 'Světle oranžová',
    [OrderColorEnum.LightGray]: 'Světle šedá',
    [OrderColorEnum.LightCoral]: 'Světle červená',
    [OrderColorEnum.White]: 'Bílá',
}
